import type { AsyncComponentLoader } from "vue";
import type { AsyncComponentOptions } from "vue";
import { defineAsyncComponent, type Component } from "vue";

export function devOnlyAsyncComponent<T extends Component>(
  component: AsyncComponentLoader<T> | AsyncComponentOptions<T>,
): T {
  return defineAsyncComponent(
    __DEV__
      ? component
      : ((() => import("@kce2/common/components/Null.tsx")) as unknown as AsyncComponentLoader<T>),
  );
}
